import React from 'react';
import PropTypes from 'prop-types';
import MUIList from '@material-ui/core/List';
import style from './List.style';

const List = ({ children, component, className, compact, role }) => (
  <MUIList
    component={component}
    role={role}
    css={[style.list.base, compact && style.list.compact]}
    className={className}
  >
    {children}
  </MUIList>
);

List.defaultProps = {
  component: 'ul',
  role: '',
  children: [],
  className: undefined,
  compact: false,
};

List.propTypes = {
  component: PropTypes.elementType,
  role: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  compact: PropTypes.bool,
};

export default React.memo(List);
